import { AdvancedFilterInputSchema } from "@redotech/redo-fulfillment-common/fulfillment-group-summary-input";
import * as z from "zod";

export const getBatchHistoryCount = {
  name: "getBatchHistoryCount" as const,
  input: AdvancedFilterInputSchema,
  output: z.object({ total: z.number() }),
};
